import { Row } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import { Link } from 'react-router-dom';
import Layout from 'app/shareable/layouts/Layout';
import FlatButtonUI from 'app/shareable/FormButton';
import navigationsRoute from 'app/routes/navigationsRoute';
import useCustomTextFieldStyles from 'app/shareable/theme/useCustomTextFieldStyles';

export default function ThankYouPage() {
  const classes = useCustomTextFieldStyles();

  return (
    <Layout captureText="One Tool. Better Way To Manage.">
      <div>
        <TextField className={classes.h1}>Thank You!</TextField>
        <div className="mt-2">
          <TextField className={classes.h3}>
            Your verification is complete, you now can start using Guesty for
            Hosts.
          </TextField>
        </div>
        <Row>
          <Link to={navigationsRoute.LOGIN_PAGE}>
            <FlatButtonUI>CLICK HERE TO LOGIN</FlatButtonUI>
          </Link>
        </Row>
      </div>
    </Layout>
  );
}
